const API_PREFIXES = [
  '/dev-api/portal/open/database',
  '/prod-api/portal/open/database'
]
export const MEMBER_CODE_STORAGE_KEY = 'portal-member-code-session'
export const MEMBER_DEVICE_ID_STORAGE_KEY = 'portal-member-device-id'

function ensureDeviceId() {
  try {
    const existing = window.localStorage.getItem(MEMBER_DEVICE_ID_STORAGE_KEY)
    if (existing) {
      return existing
    }
    let deviceId = ''
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      deviceId = window.crypto.randomUUID()
    } else {
      let d = Date.now()
      let d2 = (window.performance && window.performance.now && window.performance.now() * 1000) || 0
      deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16
        if (d > 0) {
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
    }
    window.localStorage.setItem(MEMBER_DEVICE_ID_STORAGE_KEY, deviceId)
    return deviceId
  } catch (e) {
    return ''
  }
}

function buildAuthHeaders() {
  try {
    const deviceId = ensureDeviceId()
    const session = JSON.parse(window.localStorage.getItem(MEMBER_CODE_STORAGE_KEY) || '{}')
    const headers = {}
    if (deviceId) {
      headers['X-Device-Id'] = deviceId
    }
    if (session && session.token) {
      headers.Authorization = `Bearer ${session.token}`
    }
    return headers
  } catch (e) {
    return {}
  }
  return {}
}

async function fetchWithPrefixes(path, options = {}, validateResponse) {
  let lastError = null
  for (const prefix of API_PREFIXES) {
    try {
      const response = await fetch(`${prefix}${path}`, {
        cache: 'no-store',
        ...options
      })
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }
      if (validateResponse) {
        return await validateResponse(response)
      }
      return response
    } catch (error) {
      lastError = error
    }
  }
  throw lastError || new Error('请求失败')
}

export async function fetchDatabaseFileBlob(resource) {
  const params = new URLSearchParams({ resource: resource || '' })
  return fetchWithPrefixes(`/file/preview?${params.toString()}`, {
    headers: {
      ...buildAuthHeaders()
    }
  }, async (response) => {
    const contentType = response.headers.get('content-type') || ''
    if (contentType.includes('application/json')) {
      const result = await response.json().catch(() => null)
      if (result && result.msg) {
        throw new Error(result.msg)
      }
      throw new Error('文件预览失败')
    }
    return response.blob()
  })
}

export async function previewDatabaseFile(resourceUrl) {
  const url = resourceUrl || ''
  let resource = url
  if (typeof url === 'string' && !url.startsWith('/')) {
    try {
      resource = new URL(url).pathname
    } catch (e) {
      resource = url
    }
  }
  const blob = await fetchDatabaseFileBlob(resource)
  const blobUrl = window.URL.createObjectURL(blob)
  window.open(blobUrl, '_blank')
}

async function requestJson(url, options = {}) {
  return fetchWithPrefixes(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...buildAuthHeaders(),
      ...(options.headers || {})
    }
  }, async (response) => {
    const result = await response.json()
    if (result.code !== 200) {
      throw new Error(result.msg || '请求失败')
    }
    return result
  })
}

async function requestTableData(url, options = {}) {
  return fetchWithPrefixes(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...buildAuthHeaders(),
      ...(options.headers || {})
    }
  }, async (response) => {
    const result = await response.json()
    if (!result || !Array.isArray(result.rows)) {
      throw new Error(result && result.msg ? result.msg : '请求失败')
    }
    return result
  })
}

export function fetchInnovationsHistoryList({ pageNum = 1, pageSize = 10, declareYear, category, resultsName } = {}) {
  const params = new URLSearchParams({
    pageNum: String(pageNum),
    pageSize: String(pageSize)
  })
  if (declareYear) {
    params.append('declareYear', declareYear)
  }
  if (category) {
    params.append('category', category)
  }
  if (resultsName) {
    params.append('resultsName', resultsName)
  }
  return requestTableData(`/innovationsHistory/list?${params.toString()}`)
}

export function fetchThesisHistoryList({ pageNum = 1, pageSize = 3, declareYear, topicType, keyword } = {}) {
  const params = new URLSearchParams({
    pageNum: String(pageNum),
    pageSize: String(pageSize)
  })
  if (declareYear) {
    params.append('declareYear', declareYear)
  }
  if (topicType) {
    params.append('topicType', topicType)
  }
  if (keyword) {
    params.append('keyword', keyword)
  }
  return requestTableData(`/thesisHistory/list?${params.toString()}`)
}

export function fetchDatabaseDict(dictType) {
  return requestJson(`/dict/data/type/${dictType}`)
}

export function loginByMemberCode(data) {
  return requestJson('/memberCode/login', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function fetchMemberCodeSession() {
  return requestJson('/memberCode/session')
}

export function fetchInnovationHistoryDetail(historyId) {
  return requestJson(`/innovationsHistory/${historyId}/detail`)
}

export function fetchThesisHistoryDetail(historyId) {
  return requestJson(`/thesisHistory/${historyId}/detail`)
}



// WEBPACK FOOTER //
// ./src/utils/database.js